// Next.js Link prefetch controls
//
// When true, Next.js prefetches RSC payloads for links as they enter the viewport
// (full route for static pages, up to the first loading.tsx boundary for dynamic).
//
// Prefetching has NO impact on Lighthouse scores — Lighthouse only measures initial
// page load and never scrolls or hovers to trigger viewport-based prefetch requests.
//
// However, prefetching DOES improve real-user experience and SEO:
// - Google's Core Web Vitals (CrUX) measure real navigations, not just landing pages
// - Prefetched pages load near-instantly on click, reducing bounce rate and improving engagement
// - Better engagement signals (session duration, pages per session) feed into search rankings
// - RSC prefetch payloads are small relative to images — bandwidth cost is negligible
//
// Only disable if a page has hundreds of links causing network contention.

// Controls prefetch on all <Link> components site-wide (except nav)
export const PREFETCH = true

// Controls prefetch on NavLink components in the header/navigation
export const NAV_PREFETCH = true

// Report navigation prefetches on hover/focus to avoid eager database work.
export const TRAFFIC_REPORT_PREFETCH = false
